import { MutationTree } from 'vuex'
import * as types from './mutation-types'
import UserState from '../../types/UserState'

const mutations: MutationTree<UserState> = {
  [types.TOGGLE_OTP_MODAL] (state) {
    state.otp_modal = !state.otp_modal
  },
  [types.SET_USER_STATUS] (state, payload: string) {
    state.user_status = payload
  },
  [types.SET_USER_CARDS] (state, payload: any[]) {
    state.cards = payload
  },
  [types.SELECT_USER_CARD] (state, cardName: string) {
    let card = state.cards.find(c => c.name === cardName),
      oldDefault = state.cards.find(c => c.is_default),
      idx = state.cards.indexOf(card),
      idxOld = state.cards.indexOf(oldDefault)
    card.is_default = 1
    state.cards.splice(idx, 1, card)
    if (oldDefault) {
      oldDefault.is_default = 0
      state.cards.splice(idxOld, 1, oldDefault)
    }
  },
  [types.DELETE_USER_CARD] (state, cardName: string) {
    let idx = state.cards.findIndex(card => card.name === cardName)
    state.cards.splice(idx, 1)
  },
  [types.FEE_CALCULATION_RUNNING] (state, payload: boolean) {
    state.fee_calculation_running = payload
  },
  [types.IPAY_FEE] (state, payload: number) {
    state.ipay_fee = payload
  },
  [types.SET_IPAY_ACTION_LINK] (state, payload: string) {
    state.ipay_link = payload
  },
  [types.SET_IPAY_ACTION_LINK_RUNNING] (state, payload: boolean) {
    state.ipay_link_running = payload
  }
}

export default mutations
